import authorizedAPIInstance from '@/api/authorizedAPI';
import type {
  FetchMaterialsParams,
  OutputMaterialListResponse,
} from '../utils/match-maker.types';
import { formatAPIError } from '@/utils/helpers';
export const fetchOutputMaterialList = async (
  params?: FetchMaterialsParams
): Promise<OutputMaterialListResponse> => {
  try {
    const { data } =
      await authorizedAPIInstance.get<OutputMaterialListResponse>(
        `/api/materials`,
        {
          params: params || {},
        }
      );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
